import { handleActions } from 'redux-actions';

export default handleActions(
	{
		SET_MODAL_BACKGROUND_SCROLLY: (state, action) => ({
			...state,
			globalTop: action.payload,
		}),

		OPEN_GLOBAL_MODAL: (state, action) => ({
			...state,
			[action.payload.modal]: true,
		}),

		CLOSE_GLOBAL_MODAL: (state, action) => ({
			...state,
			[action.payload.modal]: false,
		}),

		OPEN_LOGIN_SIGNUP_SUBMODAL: (state, action) => ({
			...state,
			loginSignupSubModal: {
				open: true,
				message: action.payload.message,
			},
		}),
	},
	{
		globalTop: 0,
		loginSignupSubModal: {
			open: false,
			message: '',
		},
		emailVerificationSend: false,
		emailVerifyDuplicate: false,
		codeVerificationSend: false,
		codeVerifySuccess: false,
		codeVerifyMinute: false,
		codeVerifyDuplicate: false,
		memberSaveSuccess: false,
		memberIdentityDuplicate: false,

		loginEmailConfirm: false,
		loginEmailFail: false,
		forgetEmailSend: false,
		resetPasswordSuccess: false,
		resetPasswordExpired: false,
		signupVerificationSend: false, // 自動驗證信已寄出
		signupApplyPay: false,
		coursePayATMInfo: false,
		verifyEmailFailed: false,
		verifyEmailNotyet: false,
		verifyMobileNotyet: false,
		memberInfoEmailMobileNotyet: false,
		memberInfoNotyet: false,

		courseSignupNotLogin: false,
		courseSignupNeedAddProduct: false, // 至少註冊一個商品

		addCouponFail: false,

		productLoseCheck: false,
		productLoseComplete: false,

		noProductNumber: false,
		productAddCheck: false,
		productAddSuccess: false,
		productBuyDateError: false,
		productNewRepeat: false,
		productSecondRepeat: false,
		productSellerDisagree: false,
		productSellerNotReply: false,
		productInfoError: false,

		productTransferAgree: false,
		productTransferDisagree: false,
		productTransferBeenSold: false,
		productTransferCanNotChange: false,

		reserveTypeBlacklist: false,
		reserveCanNotCancel: false,
		reserveCanNotRevise: false,
		reserveFullCount: false,

		oldSyncFail: false, // 同步舊商品失敗
		oldSyncFailSeries: false, // 同步舊商品已註冊

		eventNotMeetProduct: false, // 未符合商品的回函禮事件
		eventApplySuccess: false, // 已成功送出回函禮申請
		eventFormCheck: false, // 參加回函禮資料確定
	},
);



// WEBPACK FOOTER //
// ./src/reducers/modal.js